import { UnifiedBallotStatus } from "../../../../../shared/enums/unified-ballot-status-enum";


export interface IIecBallotSummary {
  designation: string;
  title: string;
  committee: string;
  committeeCode: string;
  iecLink: string;
  projectManagerName: string;
  projectManagerEmail: string;
  startDate: Date;
  endDate: Date;
  statusName: string;
  statusDisplayName: string;
  notes: string;
  finalisedTime?: Date | null;
  finalisedByName?: string | null;
  finalisedByEmail?: string | null;
}


export const IecBallotStatus : { [key: string]: UnifiedBallotStatus } = {
  CLOSED_FOR_VOTING : UnifiedBallotStatus.closedForVoting,
  OPEN_FOR_VOTING : UnifiedBallotStatus.openForVoting,
  SCHEDULED : UnifiedBallotStatus.scheduled,
  FINALISED : UnifiedBallotStatus.finalised
}
